import Vue from 'vue';
import VueCookies from 'vue-cookies';
import objectPath from 'object-path';

Vue.use(VueCookies);
VueCookies.config('7d');

const config = {
  flatgas: {
    validationUrl: objectPath.get(window, "SWB.FlatGasForm.validationUrl", ""),
    productsUrl: objectPath.get(window, "SWB.FlatGasForm.productsUrl", ""),
    itemId: objectPath.get(window, "SWB.FlatGasForm.itemId", ""),
    division: objectPath.get(window, "SWB.FlatGasForm.division", ""),
    unit: objectPath.get(window, "SWB.FlatGasForm.unit", ""),
    form: objectPath.get(window, "SWB.FlatGasForm.form", {}),  
    error: {
      required: objectPath.get(window, "SWB.FlatGasForm.error.required", ""),
      zipcodInvalidFormat: objectPath.get(window, "SWB.FlatGasForm.error.zipcodInvalidFormat", ""), 
      consumptionInvalidFormat: objectPath.get(window, "SWB.FlatGasForm.error.consumptionInvalidFormat", ""),
      consumptionRangeValidation:objectPath.get(window, "SWB.FlatGasForm.error.consumptionRangeValidation", ""),
      generalErrorMessage:objectPath.get(window, "SWB.FlatGasForm.error.generalErrorMessage", ""),
    },
    code:{
      general:"0",
      zipcode:"1",
      zipcodeNotAvailableHint:"2",
      zipcodeOutOfRangeHint:"4",
      consumption:"10",    
    },
    cookieName:"swb_calc_gas"
  },
  productCampaign: {
    form: {
      itemUrlText: objectPath.get(window, "SWB.ProductCampaign.form.itemUrlText", ""),
    },
    campaignModel: objectPath.get(window, "SWB.ProductCampaign.campaignModel", {})
  }
};

export default {
  ...config
};
